module.exports = __webpack_public_path__ + "static/shop-06324719aca5760816e2333d9e056395.svg";